/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChargeSort } from '../models/ChargeSort';
import type { ChargeStatus } from '../models/ChargeStatus';
import type { CreatePaymentRequest } from '../models/CreatePaymentRequest';
import type { CreatePaymentResponse } from '../models/CreatePaymentResponse';
import type { ExportFormat } from '../models/ExportFormat';
import type { GetBalanceResponse } from '../models/GetBalanceResponse';
import type { ListChargesResult } from '../models/ListChargesResult';
import type { ListPaymentsResult } from '../models/ListPaymentsResult';
import type { mccs_charge_payment_type } from '../models/mccs_charge_payment_type';
import type { PaymentDetail } from '../models/PaymentDetail';
import type { PaymentManagementListResult } from '../models/PaymentManagementListResult';
import type { PaymentManagementReportSummary } from '../models/PaymentManagementReportSummary';
import type { PaymentManagementTotals } from '../models/PaymentManagementTotals';
import type { PaymentMethod } from '../models/PaymentMethod';
import type { PaymentSort } from '../models/PaymentSort';
import type { PaymentStatus } from '../models/PaymentStatus';
import type { SortDirection } from '../models/SortDirection';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentsService {
  /**
   * List charges, filtering by various criteria.
   * @param query
   * @param businessEntityId
   * @param status
   * @param createdAt
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListChargesResult OK
   * @throws ApiError
   */
  public static listCharges(
    query?: string,
    businessEntityId?: string,
    status?: Array<ChargeStatus>,
    createdAt?: string,
    limit?: number,
    offset?: number,
    sortBy?: ChargeSort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListChargesResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/charges',
      query: {
        'query': query,
        'businessEntityId': businessEntityId,
        'status': status,
        'createdAt': createdAt,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Get the current outstanding balance.
   * @param businessEntityId
   * @returns GetBalanceResponse OK
   * @throws ApiError
   */
  public static getBalance(
    businessEntityId?: string,
  ): CancelablePromise<GetBalanceResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/balance',
      query: {
        'businessEntityId': businessEntityId,
      },
    });
  }
  /**
   * Create a new payment, applying it to existing charges. Total payment amount is derived from the sum of the applied charges.
   * @param requestBody
   * @returns CreatePaymentResponse Created
   * @throws ApiError
   */
  public static createPayment(
    requestBody?: CreatePaymentRequest,
  ): CancelablePromise<CreatePaymentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Payments',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * List payments, filtering by various criteria.
   * @param businessEntityId
   * @param paymentMethod
   * @param status
   * @param createdAt
   * @param referenceNumber
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns ListPaymentsResult OK
   * @throws ApiError
   */
  public static listPayments(
    businessEntityId?: string,
    paymentMethod?: Array<PaymentMethod>,
    status?: Array<PaymentStatus>,
    createdAt?: string,
    referenceNumber?: string,
    limit?: number,
    offset?: number,
    sortBy?: PaymentSort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<ListPaymentsResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/payments',
      query: {
        'businessEntityId': businessEntityId,
        'paymentMethod': paymentMethod,
        'status': status,
        'createdAt': createdAt,
        'referenceNumber': referenceNumber,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * List payment-grain rows for the internal Payments Management table, filtering by various criteria. Returns JSON by default, or a CSV/PDF of every matching row (ignoring pagination) when format is specified.
   * @param businessEntityId
   * @param paymentMethod
   * @param status
   * @param referenceNumber
   * @param query
   * @param paymentType
   * @param paidFrom
   * @param paidTo
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @param format
   * @returns PaymentManagementListResult OK
   * @throws ApiError
   */
  public static listPaymentManagementRows(
    businessEntityId?: string,
    paymentMethod?: Array<PaymentMethod>,
    status?: Array<PaymentStatus>,
    referenceNumber?: string,
    query?: string,
    paymentType?: Array<mccs_charge_payment_type>,
    paidFrom?: string,
    paidTo?: string,
    limit?: number,
    offset?: number,
    sortBy?: PaymentSort,
    sortDirection?: SortDirection,
    format?: ExportFormat,
  ): CancelablePromise<PaymentManagementListResult> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/management-rows',
      query: {
        'businessEntityId': businessEntityId,
        'paymentMethod': paymentMethod,
        'status': status,
        'referenceNumber': referenceNumber,
        'query': query,
        'paymentType': paymentType,
        'paidFrom': paidFrom,
        'paidTo': paidTo,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
        'format': format,
      },
    });
  }
  /**
   * Get aggregate totals (count/applied/remaining) for the internal Payments Management results summary, filtering by the same criteria as ListPaymentManagementRows.
   * @param businessEntityId
   * @param paymentMethod
   * @param status
   * @param referenceNumber
   * @param query
   * @param paymentType
   * @param paidFrom
   * @param paidTo
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns PaymentManagementTotals OK
   * @throws ApiError
   */
  public static getPaymentManagementTotals(
    businessEntityId?: string,
    paymentMethod?: Array<PaymentMethod>,
    status?: Array<PaymentStatus>,
    referenceNumber?: string,
    query?: string,
    paymentType?: Array<mccs_charge_payment_type>,
    paidFrom?: string,
    paidTo?: string,
    limit?: number,
    offset?: number,
    sortBy?: PaymentSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<PaymentManagementTotals> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/management-totals',
      query: {
        'businessEntityId': businessEntityId,
        'paymentMethod': paymentMethod,
        'status': status,
        'referenceNumber': referenceNumber,
        'query': query,
        'paymentType': paymentType,
        'paidFrom': paidFrom,
        'paidTo': paidTo,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
    });
  }
  /**
   * Get the live summary (count/applied/remaining at charge-allocation grain) for the Generate Report dialog, filtering by the same criteria as ListPaymentManagementRows.
   * @param businessEntityId
   * @param paymentMethod
   * @param status
   * @param referenceNumber
   * @param query
   * @param paymentType
   * @param paidFrom
   * @param paidTo
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns PaymentManagementReportSummary OK
   * @throws ApiError
   */
  public static getPaymentManagementReportSummary(
    businessEntityId?: string,
    paymentMethod?: Array<PaymentMethod>,
    status?: Array<PaymentStatus>,
    referenceNumber?: string,
    query?: string,
    paymentType?: Array<mccs_charge_payment_type>,
    paidFrom?: string,
    paidTo?: string,
    limit?: number,
    offset?: number,
    sortBy?: PaymentSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<PaymentManagementReportSummary> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/management-report-summary',
      query: {
        'businessEntityId': businessEntityId,
        'paymentMethod': paymentMethod,
        'status': status,
        'referenceNumber': referenceNumber,
        'query': query,
        'paymentType': paymentType,
        'paidFrom': paidFrom,
        'paidTo': paidTo,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
    });
  }
  /**
   * Download the Generate Report dialog's CSV, filtering by the same criteria as ListPaymentManagementRows.
   * @param businessEntityId
   * @param paymentMethod
   * @param status
   * @param referenceNumber
   * @param query
   * @param paymentType
   * @param paidFrom
   * @param paidTo
   * @param limit
   * @param offset
   * @param sortBy
   * @param sortDirection
   * @returns any OK
   * @throws ApiError
   */
  public static getPaymentManagementReport(
    businessEntityId?: string,
    paymentMethod?: Array<PaymentMethod>,
    status?: Array<PaymentStatus>,
    referenceNumber?: string,
    query?: string,
    paymentType?: Array<mccs_charge_payment_type>,
    paidFrom?: string,
    paidTo?: string,
    limit?: number,
    offset?: number,
    sortBy?: PaymentSort,
    sortDirection?: SortDirection,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/management-report',
      query: {
        'businessEntityId': businessEntityId,
        'paymentMethod': paymentMethod,
        'status': status,
        'referenceNumber': referenceNumber,
        'query': query,
        'paymentType': paymentType,
        'paidFrom': paidFrom,
        'paidTo': paidTo,
        'limit': limit,
        'offset': offset,
        'sortBy': sortBy,
        'sortDirection': sortDirection,
      },
    });
  }
  /**
   * Get full detail for one payment for the internal Payments Management dialog.
   * @param paymentId
   * @returns PaymentDetail OK
   * @throws ApiError
   */
  public static getPaymentManagementDetail(
    paymentId: string,
  ): CancelablePromise<PaymentDetail> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Payments/{paymentId}/management-detail',
      path: {
        'paymentId': paymentId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
}
